import { Movement } from 'types';

import { createMovement } from 'modules/transactions/utils/createMovement';
import movementTypes from 'modules/transactions/constants/movementTypes';

import { CustomRange } from '../types/CustomRange';

type GetMovementsParams = {
  reassignedRanges: CustomRange[];
};

export const getMovements = ({ reassignedRanges }: GetMovementsParams) => {
  const reclassificationMovements = reassignedRanges.map(
    (range: CustomRange) =>
      createMovement({
        range,
        newFrom: range.newFrom,
        newTo: range.newTo,
        movementType: movementTypes.MANUAL_RENUMERATION,
      }) as Movement
  );

  return reclassificationMovements;
};
